import { useIsMobile } from '@/data/hooks/useIsMobile';
import { combineSX } from '@/utils/combineSX';
import { Box, Stack, styled, useTheme, SxProps } from '@mui/material';
import Slider from 'react-slick';

const baseSettings = {
	dots: false,
	infinite: true,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 3000,
};

const Img = styled('img')({
	maxWidth: '100%',
});

export const DpDeportesEntrenamientoBannersTwoAds = ({
	image1,
	image2,
	sximg,
	href1,
	href2,
}: {
	image1:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;
	image2:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;
	sximg: SxProps;
	href1: string;
	href2: string;
}) => {
	const theme = useTheme();
	const isMobile = useIsMobile();
	const getImage1 =
		typeof image1 === 'string' ? image1 : isMobile ? image1?.mobile : image1?.desktop;
	const getImage2 =
		typeof image2 === 'string' ? image2 : isMobile ? image2?.mobile : image2?.desktop;

	const getImage = (image: any) =>
		typeof image === 'string' ? image : isMobile ? image.mobile : image.desktop;

	const imagesSlider = [getImage(image1), getImage(image2)];

	const settings = {
		...baseSettings,
		slidesToShow: 1,
		responsive: [
			{
				breakpoint: theme.breakpoints.values.sm,
				settings: {
					...baseSettings,
					slidesToShow: 1,
				},
			},
		],
	};

	return (
		<>
			{isMobile ? (
				<Box mt="40px" width="100%" maxWidth="450px" mx="auto">
					<Slider {...settings}>
						{imagesSlider.map((src, index) => {
							const href = index === 0 ? href1 : href2;
							const imgElement = <Img src={src} />;

							return href ? (
								<a key={index} href={href}>
									{imgElement}
								</a>
							) : (
								imgElement
							);
						})}
					</Slider>
				</Box>
			) : (
				<Stack direction={'row'} spacing={1} sx={{ mt: '40px', maxWidth: '1280px' }}>
					<Stack direction={'column'}>
						<a href={href1}>
							<Img sx={combineSX([...(Array.isArray(sximg) ? sximg : [sximg])])} src={getImage1} />
						</a>
					</Stack>
					<Stack direction={'column'}>
						<a href={href2}>
							<Img
								sx={combineSX([{ ml: '32px' }, ...(Array.isArray(sximg) ? sximg : [sximg])])}
								src={getImage2}
							/>
						</a>
					</Stack>
				</Stack>
			)}
		</>
	);
};
